/**
 * Type-safe wrapper for react-helmet with React 18 compatibility
 *
 * react-helmet@5.2.0's types don't fully align with React 18's stricter JSX requirements,
 * but the library works perfectly at runtime. This wrapper provides proper typing while
 * maintaining full functionality.
 */

import { Helmet as ReactHelmet } from "react-helmet";
import type { HelmetProps } from "react-helmet";

export const Helmet = ReactHelmet as unknown as React.FC<HelmetProps>;

export type { HelmetProps };
